import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router'
import { ModalBigCentered, ButtonsModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import { OrderWorkingCenterIdCustomSelect, OrderCurrencyIdCustomSelect } from '../../../../../../baseComponents/ModalsLayouts/ModalOrderIncompatibles/Subcomponents'
import twinFetchPost from '../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../utils/reducers/reduxDispatch'
import { parseMultiSelectedTableForProcessing } from '../../../../../inputTableLayouts/order/OrderLayout/useMultiOrderScreenLogic/functions'
import { ModalProcessMultiSellBaseLogicProps, ModalProcessMultiSellBaseProps } from '../types'
import './modalProcessMultiSell.sass'

type ModalProcessMultiSellProps = ModalProcessMultiSellBaseProps  & ModalProcessMultiSellLogicProps & { }

const ModalProcessMultiSell: React.FC<ModalProcessMultiSellProps> = ({ setOpened, data, conflicts, sellInfo, translateText,  ...logic}) => {
    const { handleConflict, mySellInfo, finalizeOrder, loading } = useModalProcessMultiSellLogic({ data, sellInfo, setOpened, ...logic })
    const {t} = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    const dictConflictComponents: TwinDictionary = {
        'WorkingCenterId': { component: OrderWorkingCenterIdCustomSelect, extraData: {label: t('soldBy', 'Vendido por')}},
        'CurrencyId':  { component: OrderCurrencyIdCustomSelect} 
    }
    for (const key in conflicts.conflicts) {
        const conflict = conflicts.conflicts[key]
        if(dictConflictComponents?.[conflict]){
            const Component = dictConflictComponents?.[conflict].component
            renderThis.push(<Component field={conflict} {...{ handleConflict, ...dictConflictComponents?.[conflict]?.extraData}} header={mySellInfo} pos={parseInt(key)} />)
        }
    }
    return (
        <ModalBigCentered opened={true} setOpened={() => setOpened(null)} onClickOut={false} className='flex modal_process_multi_sell'>
            <div className='flex flex-col modal_process_multi_sell_container'>
                <div className='process_buy_order'>
                    <h4 className=''>{translateText.titleText}</h4>
                </div>
                {conflicts.conflicts?.length ? 
                    <div className='my-20'>
                        <div className='text-left'>
                            {translateText.conflictText}
                        </div>
                        <div className='my-30'>
                            {renderThis}
                        </div>
                    </div> 
                    : <div className='my-20'>
                        {translateText.confirmText}
                    </div> 
                }
                <ButtonsModalSmallCentered confirmText={t('create', 'Crear')} setOpened={() => setOpened(null)} onAccept={() => finalizeOrder()} loading={loading} />
            </div>
        </ModalBigCentered>
    )
}

interface ModalProcessMultiSellLogicProps extends ModalProcessMultiSellBaseLogicProps {
    setOpened: ModalOpenedSetTy
}

const useModalProcessMultiSellLogic = ({ data, sellInfo, setOpened, urlNavigate, urlProcess }: ModalProcessMultiSellLogicProps) => {
    const {t} = useTwinTranslation()
    const {loading, startLoading} = useIsLoading()
    const [mySellInfo, setMySellInfo] = useState<TwinDictionary>(sellInfo)
    const navigate = useNavigate()

    const handleConflict = useCallback((field: string, value: string) => {
        setMySellInfo((old) => {
            if (!old) {
                return null
            }
            const parsedOld = JSON.parse(JSON.stringify(old))
            parsedOld[field] = value
            return { ...parsedOld }
        })
    }, [])
    const noProductsMsg = t('notProcessedAnyProducts', 'No has procesado ningún producto')
    const errorQuantityRequired = t('quantityIsRequired', 'Es necesario procesar productos con cantidad')
    const finalizeOrder = useCallback(async () => {
        startLoading()
        const selectedProducts = parseMultiSelectedTableForProcessing(data)
        delete sellInfo.Customer
        if (selectedProducts.forSend.products.length){
            const response = await twinFetchPost(urlProcess, { selectedProducts: selectedProducts.forSend.products, sellInfo: {...sellInfo, ...mySellInfo} })
            const responseJSON = await response.json()
            if (response.status === 200) {
                if (responseJSON !== false) {
                    navigate(urlNavigate + '/' + responseJSON.id)
                }
            } else {
                if (responseJSON.errors[0].msg === 'noProducts') {
                    changeErrorMessage(noProductsMsg)
                } else if (responseJSON.errors[0].msg === 'Products are required') {
                    changeErrorMessage(errorQuantityRequired)
                } else{
                    changeErrorMessage(responseJSON.errors[0].msg)
                }
            }
        }else {
            changeErrorMessage(errorQuantityRequired)
        }
        setOpened(null)
    }, [navigate, setOpened, data, sellInfo, mySellInfo, noProductsMsg, errorQuantityRequired, startLoading, urlNavigate, urlProcess])
    
    return { handleConflict, mySellInfo, finalizeOrder, loading }

}

export default ModalProcessMultiSell